import React from 'react';
import { useT } from '../../i18n/useT';
import './SecuritySection.css';

const ICONS = [
  (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 2L4 5.5v6c0 5.5 3.5 9.5 8 11 4.5-1.5 8-5.5 8-11v-6L12 2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M9 12l2.5 2.5 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>),
  (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="4" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M8 12l3 3 5-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>),
  (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 4v8M9 19h6M12 12v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M5 17h14v1a2 2 0 01-2 2H7a2 2 0 01-2-2v-1z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>),
];

export default function SecuritySection() {
  const t = useT();
  const s = t.security;
  return (
    <section className="security section" aria-labelledby="security-heading">
      <div className="container">
        <div className="security__header section-header">
          <div className="badge">{s.badge}</div>
          <h2 id="security-heading" style={{ marginTop: 'var(--space-4)' }}>
            {s.headline} <span className="gradient-text">{s.headlineAccent}</span>
          </h2>
          <p>{s.sub}</p>
        </div>
        <div className="security__grid">
          {s.items.map((item, i) => (
            <div key={i} className="security__card">
              <div className="security__card-icon" aria-hidden="true">{ICONS[i]}</div>
              <h3 className="security__card-title">{item.title}</h3>
              <p className="security__card-desc">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
